import { render, staticRenderFns } from "./topup.vue?vue&type=template&id=6c486d42&scoped=true"
import script from "./topup.vue?vue&type=script&lang=js"
export * from "./topup.vue?vue&type=script&lang=js"
import style0 from "./topup.vue?vue&type=style&index=0&id=6c486d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c486d42",
  null
  
)

export default component.exports